<template>
  <div>
    <v-row dense class="mx-1">
      <v-btn v-if="hasRoleCadastroProduto"
             color="primary"
             class="normal-btn-text rounded-tag-small elevation-0"
             link to="/cadastro-produto">
        <v-icon left>mdi-plus</v-icon>
        Produto
      </v-btn>
      <v-spacer/>
      <v-btn icon @click="onClickRefresh">
        <v-icon left>mdi-refresh</v-icon>
      </v-btn>
      <px-produtos-filter @change="onChangeFilter"/>
      <px-search-text label="Busque produto" class="rounded-tag-small" v-model="searchText"
                      style="max-width: 400px"
                      :on-search="onChangeSearchText"/>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ProdutosFilter from './ProdutosListFilter.vue';

export default {
  props: {
    onClickRefresh: {
      type: Function,
      required: true,
    },
    onChangeFilter: {
      type: Function,
      required: true,
    },
  },
  computed: {
    ...mapGetters('listagemProdutos', ['stringFilter']),
    ...mapGetters('user', ['hasRoleCadastroProduto']),
    searchText: {
      get() {
        return this.$store.getters['listagemProdutos/searchText'];
      },
      set(searchText) {
        this.$store.dispatch('listagemProdutos/searchText', searchText);
      },
    },
  },
  methods: {
    onChangeSearchText() {
      this.onChangeFilter(this.stringFilter);
    },
    onSelectItem() {
      this.onChangeFilter(this.stringFilter);
    },
  },
  components: {
    pxProdutosFilter: ProdutosFilter,
  },
};
</script>
